import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Marca } from '../../core/models/marca';
import { MarcaService } from 'src/app/core/services/marca.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-marca',
  templateUrl: './marca.component.html',
  styleUrls: ['./marca.component.scss'],
})
export class MarcaComponent implements OnInit, OnDestroy {
  marca = new Marca();
  marcas: Marca[] = [];

  editMode = false;
  editMarcaId: number | null = null;
  isProcessingId: number | null = null;

  @ViewChild('marcaForm') marcaForm?: NgForm;

  private destroy$ = new Subject<void>();

  constructor(
    private readonly servico: MarcaService,
    private readonly messageService: MessageService,
    private readonly confirmation: ConfirmationService,

  ) {}

  selecionar(): void {
    this.servico.selecionar().subscribe((retorno) => (this.marcas = retorno));
  }

  cadastrar(): void {
    this.servico.cadastrar(this.marca).subscribe({
      next: (retorno) => {
        this.marcas.push(retorno);
        this.marca = new Marca();
        this.messageService.add({severity:'success', summary:'Sucesso', detail:'Marca cadastrada'});
      },
      error: (err) => {
        let userMessage = 'Erro ao cadastrar marca';
        if (Array.isArray(err.body)) {
          userMessage = err.body.join(' | ');
        } else if (err && err.message) {
          userMessage = err.message;
        } else if (err && err.error && err.error.message) {
          userMessage = err.error.message;
        } else if (typeof err === 'string') {
          userMessage = err;
        }
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: userMessage });
        // Não redireciona, apenas exibe mensagem
        console.error('Erro ao cadastrar marca:', err);
      }
    });
  }

  alterar(): void {
    this.servico.alterar(this.marca).subscribe({
      next: (ret) => {
        const idx = this.marcas.findIndex((m) => m.id === ret.id);
        if (idx >= 0) this.marcas[idx] = ret;
        this.messageService.add({severity:'success', summary:'Sucesso', detail:'Marca alterada'});
        this.marca = new Marca();
        this.editMode = false;
      },
      error: (err) => {
        let userMessage = 'Erro ao alterar marca';
        if (Array.isArray(err.body)) {
          userMessage = err.body.join(' | ');
        } else if (err && err.message) {
          userMessage = err.message;
        } else if (err && err.error && err.error.message) {
          userMessage = err.error.message;
        } else if (typeof err === 'string') {
          userMessage = err;
        }
        this.messageService.add({severity:'error', summary:'Erro', detail:userMessage});
        console.error('Erro ao alterar marca:', err);
      }
    });
  }

  onSubmit(): void {
    if (this.editMode) this.alterar();
    else this.cadastrar();
  }

  // inicia edição populando o formulário
  editar(m: Marca): void {
    this.editMode = true;
    this.editMarcaId = m.id ?? null;
    this.marca = { ...m } as Marca;
  }

    cancelarEdicao(): void {
      this.editMode = false;
      this.editMarcaId = null;
      this.marca = new Marca();
      // reset template-driven form if present
    try {
      this.marcaForm?.resetForm(this.marca);
    } catch (e) {
      // ignore if form not available
    }
    }

  // limpa o formulário
  limparFormulario(): void {
    this.marca = new Marca();
    this.editMode = false;
  }

    salvarAlteracao(): void {
    if (!this.editMode || this.editMarcaId == null) return;
    // garante que o objeto contenha o id correto
    this.marca.id = this.editMarcaId;
    this.servico.alterar(this.marca).subscribe({
      next: (ret) => {
        const idx = this.marcas.findIndex((x) => x.id === this.editMarcaId);
        if (idx >= 0) this.marcas[idx] = ret;
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Marca alterada com sucesso.' });
        this.cancelarEdicao();
      },
      error: (err) => {
        let userMessage = 'Erro ao alterar marca';
        if (Array.isArray(err.body)) {
          userMessage = err.body.join(' | ');
        } else if (err && err.message) {
          userMessage = err.message;
        } else if (err && err.error && err.error.message) {
          userMessage = err.error.message;
        } else if (typeof err === 'string') {
          userMessage = err;
        }
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: userMessage });
        console.error('Erro ao alterar marca:', err);
      },
    });
   }

  confirmarAtivarDesativar(marca: Marca | undefined): void {
    if (!marca?.id) return;
    const willDeactivate = !!marca.ativo;
    const actionLabel = willDeactivate ? 'desativar' : 'ativar';

    this.confirmation.confirm({
      message: `Confirma ${actionLabel} o marca ${marca.nome || marca.id}?`,
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.servico.ativarDesativar(marca.id as number, !willDeactivate).subscribe({
          next: (ret) => {
            const idx = this.marcas.findIndex((u) => u.id === marca.id);
            if (idx >= 0) {
              if (ret) this.marcas[idx] = ret;
              else this.marcas[idx].ativo = !willDeactivate;
            }
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: `Marca ${willDeactivate ? 'desativada' : 'ativada'} com sucesso.` });
          },
          error: (err) => {
            const msg = err?.error?.message || err?.message || `Erro ao ${actionLabel} marca`;
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
            console.error(`Erro ao ${actionLabel} marca:`, err);
          },
        });
      },
    });
  }

  //Método de inicialização
  ngOnInit() {
    this.selecionar();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
